import PropTypes from 'prop-types';
import { useTranslation, I18nextProvider } from 'react-i18next';
import { useState, useEffect } from 'react';
import Icon, { defaultColors } from '@digitransit-component/digitransit-component-icon';
import { Modal, ModalContent } from '@hsl-fi/dialog';
import { Text } from '@hsl-fi/layout-primitives';
import { jsx, jsxs } from 'react/jsx-runtime';
import Shimmer from '@hsl-fi/shimmer';
import { createInstance } from 'i18next';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".styles_input__mup3U {\n  width: 200px;\n}\n\n.styles_main-left__ixZGH {\n  display: flex;\n  order: 1;\n  flex-direction: column;\n  align-items: stretch;\n  background-color: #fff;\n  height: 100%;\n  width: calc(100% - 2em);\n  max-width: 399px;\n  z-index: 20;\n  margin: 0 auto;\n}\n\n.styles_main-bottom__M4zXb {\n  background-color: #fff;\n  width: calc(100% - 40px);\n  margin: 0 20px;\n  padding-bottom: 32px;\n}\n\n.styles_separator-div__0QdvP {\n  position: relative;\n  display: block;\n  width: 100%;\n  margin-bottom: 25px;\n  padding-bottom: 21px;\n}\n@media screen and (min-width: 768px) {\n  .styles_separator-div__0QdvP {\n    padding-bottom: 31px;\n    margin-bottom: 20px;\n  }\n}\n\n.styles_separator-div2__CtWdO {\n  position: relative;\n  display: block;\n  width: 100%;\n  margin-bottom: 15px;\n  padding-bottom: 21px;\n}\n@media screen and (min-width: 768px) {\n  .styles_separator-div2__CtWdO {\n    margin-bottom: 26px;\n    padding-bottom: 21px;\n  }\n}\n\n.styles_separator-line__xZ3Qv {\n  background-color: #ccc;\n  content: \"\";\n  display: block;\n  height: 1px;\n  position: absolute;\n  bottom: 0;\n  right: -5px;\n  left: -5px;\n}\n@media screen and (min-width: 768px) {\n  .styles_separator-line__xZ3Qv {\n    right: -10px;\n    left: -10px;\n  }\n}\n\n.styles_separator__ksbHT {\n  background-color: var(--color-border-weak);\n  height: 1px;\n}\n@media (min-width: 500px) {\n  .styles_separator__ksbHT {\n    margin: 0 -8px;\n  }\n}\n\n.styles_modal-rows__fnabq {\n  margin-top: var(--space-fixed-xs);\n  --iconSize: 24px;\n}\n@media (min-width: 500px) {\n  .styles_modal-rows__fnabq {\n    --iconSize: 32px;\n    margin-top: 0;\n    margin-bottom: calc(var(--space-s) + var(--space-fixed-xxs) - var(--space-fixed-m));\n  }\n}\n\n.styles_near-you-container__XFf0v {\n  font-size: 16px;\n}\n.styles_near-you-container__XFf0v .styles_near-you-title__FXRoy {\n  font-family: inherit;\n  font-weight: var(--font-weight-medium, 500);\n  line-height: normal;\n  letter-spacing: -0.67px;\n  color: #333;\n  font-size: 1.125em;\n}\n@media screen and (min-width: 768px) {\n  .styles_near-you-container__XFf0v .styles_near-you-title__FXRoy {\n    letter-spacing: -0.6px;\n    font-size: 1.25em;\n    margin: 0 0 18px 0;\n  }\n}\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container__NKcMS {\n  display: flex;\n}\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container__NKcMS > div:not(:last-child) {\n  margin-right: 7px;\n}\n@media screen and (min-width: 768px) {\n  .styles_near-you-container__XFf0v .styles_near-you-buttons-container__NKcMS > div:not(:last-child) {\n    margin-right: 8px;\n  }\n}\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container__NKcMS > div:last-child {\n  margin-bottom: 32px;\n}\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container__NKcMS > div {\n  display: flex;\n  flex: 1;\n  width: 100%;\n  height: 42px;\n}\n@media screen and (min-width: 768px) {\n  .styles_near-you-container__XFf0v .styles_near-you-buttons-container__NKcMS > div {\n    min-width: 50px;\n    max-width: 72px;\n    height: 50px;\n  }\n}\n.styles_near-you-container__XFf0v .styles_near-you-button-with-border__80r3- {\n  border: solid 1px #ddd;\n  border-radius: 5px;\n  cursor: pointer;\n  background-color: white;\n  display: flex;\n  flex: 1;\n  width: 100%;\n  justify-content: center;\n  max-width: 72px;\n  height: 100%;\n}\n.styles_near-you-container__XFf0v .styles_near-you-button-with-border__80r3- .styles_icon-container__qKWFg {\n  display: flex;\n}\n.styles_near-you-container__XFf0v .styles_near-you-button-with-border__80r3- span.styles_transport-mode-alert-icon__7iMFH {\n  position: absolute;\n  bottom: -4px;\n  left: calc(50% + 10px);\n}\n.styles_near-you-container__XFf0v .styles_near-you-button-with-border__80r3- span.styles_transport-mode-alert-icon__7iMFH svg {\n  height: 15px !important;\n  width: 15px !important;\n}\n@media screen and (min-width: 768px) {\n  .styles_near-you-container__XFf0v .styles_near-you-button-with-border__80r3- span.styles_transport-mode-alert-icon__7iMFH svg {\n    width: 18px !important;\n    height: 18px !important;\n  }\n}\n.styles_near-you-container__XFf0v .styles_near-you-button-with-border__80r3- svg {\n  width: 30px;\n  height: 30px;\n  margin: auto;\n}\n@media screen and (min-width: 768px) {\n  .styles_near-you-container__XFf0v .styles_near-you-button-with-border__80r3- svg {\n    width: 34px;\n    height: 34px;\n  }\n}\n.styles_near-you-container__XFf0v .styles_near-you-button-with-border__80r3-:hover {\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);\n}\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button__1D89O,\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button-with-border__80r3- {\n  margin-bottom: var(--margin);\n  margin-top: var(--margin);\n  padding-bottom: var(--padding);\n  padding-top: var(--padding);\n  cursor: pointer;\n  display: flex;\n  background-color: white;\n  flex: 1;\n  min-width: 100%;\n}\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button__1D89O .styles_icon-container__qKWFg,\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button-with-border__80r3- .styles_icon-container__qKWFg {\n  cursor: pointer;\n  display: flex;\n  margin-left: var(--iconMargin);\n  border-radius: var(--borderRadius);\n  background-color: var(--bckColor);\n  height: var(--iconSize, 30px);\n  width: var(--iconSize, 30px);\n  flex-shrink: 0;\n  align-items: center;\n  align-self: center;\n  justify-content: center;\n}\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button__1D89O .styles_icon-container__qKWFg > svg,\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button-with-border__80r3- .styles_icon-container__qKWFg > svg {\n  width: 100%;\n  height: 100%;\n}\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button__1D89O .styles_icon-container__qKWFg span.styles_transport-mode-alert-icon__7iMFH,\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button-with-border__80r3- .styles_icon-container__qKWFg span.styles_transport-mode-alert-icon__7iMFH {\n  position: absolute;\n  top: 28px;\n  left: 32px;\n}\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button__1D89O .styles_icon-container__qKWFg span.styles_transport-mode-alert-icon__7iMFH svg,\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button-with-border__80r3- .styles_icon-container__qKWFg span.styles_transport-mode-alert-icon__7iMFH svg {\n  height: 15px !important;\n  width: 15px !important;\n}\n@media screen and (min-width: 768px) {\n  .styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button__1D89O .styles_icon-container__qKWFg span.styles_transport-mode-alert-icon__7iMFH svg,\n  .styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button-with-border__80r3- .styles_icon-container__qKWFg span.styles_transport-mode-alert-icon__7iMFH svg {\n    width: 18px !important;\n    height: 18px !important;\n  }\n}\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button__1D89O .styles_transport-mode-title__Yr0my,\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button-with-border__80r3- .styles_transport-mode-title__Yr0my {\n  cursor: pointer;\n  font-style: normal;\n  font-weight: var(--font-weight, var(--font-weight-medium, 500));\n  font-size: 15px;\n  line-height: 18px;\n  margin-left: 9px;\n  align-self: center;\n  text-align: left;\n  width: calc(100% - 58px);\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button-caret__1LEaK {\n  align-self: center;\n}\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button__1D89O:hover .styles_near-you-button-caret__1LEaK {\n  transform: translateX(4px);\n  transition: transform 0.1s;\n}\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button-with-border__80r3- {\n  border: solid 1px #d9d9d9;\n}\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button-with-border__80r3-:hover {\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);\n}";
var styles = {"input":"styles_input__mup3U","main-left":"styles_main-left__ixZGH","main-bottom":"styles_main-bottom__M4zXb","separator-div":"styles_separator-div__0QdvP","separator-div2":"styles_separator-div2__CtWdO","separator-line":"styles_separator-line__xZ3Qv","separator":"styles_separator__ksbHT","modal-rows":"styles_modal-rows__fnabq","near-you-container":"styles_near-you-container__XFf0v","near-you-title":"styles_near-you-title__FXRoy","near-you-buttons-container":"styles_near-you-buttons-container__NKcMS","near-you-button-with-border":"styles_near-you-button-with-border__80r3-","icon-container":"styles_icon-container__qKWFg","transport-mode-alert-icon":"styles_transport-mode-alert-icon__7iMFH","near-you-buttons-container-wide":"styles_near-you-buttons-container-wide__2Z-wf","near-you-button":"styles_near-you-button__1D89O","transport-mode-title":"styles_transport-mode-title__Yr0my","near-you-button-caret":"styles_near-you-button-caret__1LEaK"};
styleInject(css_248z);

function AllModesModal({
  modalOpen,
  closeModal,
  language,
  children
}) {
  const [t] = useTranslation();
  return /*#__PURE__*/jsx(Modal, {
    lang: language,
    open: modalOpen,
    onOpenChange: open => {
      if (!open) {
        closeModal();
      }
    },
    children: /*#__PURE__*/jsx(ModalContent, {
      lang: language,
      title: t('title', {
        lng: language
      }),
      description: /*#__PURE__*/jsx(Text, {
        variant: "paragraph-small",
        fixedSize: "desktop",
        color: "default",
        children: t('description', {
          lng: language
        })
      }),
      buttons: [{
        children: t('close', {
          lng: language
        }),
        variant: 'primary',
        onClick: closeModal
      }],
      children: /*#__PURE__*/jsx("div", {
        className: `${styles['near-you-container']} ${styles['modal-rows']}`,
        children: /*#__PURE__*/jsx("div", {
          className: styles['near-you-buttons-container-wide'],
          children: children
        })
      })
    })
  });
}
process.env.NODE_ENV !== "production" ? AllModesModal.propTypes = {
  language: PropTypes.string.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  children: PropTypes.arrayOf(PropTypes.node).isRequired
} : void 0;

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}

const VALID_NEAR_YOU_MODES = ['favorite', 'bus', 'tram', 'rail', 'subway', 'airplane', 'ferry', 'citybike', 'bikepark', 'carpark'];
const NO_THEME_MODES = ['bikepark', 'carpark', 'subway', 'airplane']; // common icon in all themes

const SELECTION_KEYS = ['Enter', ' ', 'Spacebar'];
function getIconName(mode, modeSet, boxed) {
  const theme = NO_THEME_MODES.includes(mode) ? '' : `-${modeSet}`;
  const fill = boxed ? '' : '-fill'; // do not render boxed icon for vertical
  return `${mode}${fill}${theme}`;
}
function isKeyboardSelectionEvent(event) {
  if (!SELECTION_KEYS.includes(event?.key)) {
    return false;
  }
  event.preventDefault();
  return true;
}

/** Builds the near you url for a mode, e.g. /fi/nearyou/BUS/POS/Address::lat,lon */
function getModeUrl({
  urlPrefix,
  language,
  omitLanguageUrl,
  origin,
  mode
}) {
  let urlStart = urlPrefix;
  if (!omitLanguageUrl) {
    const urlParts = urlPrefix.split('/');
    urlParts.splice(urlParts.length - 1, 0, language);
    urlStart = urlParts.join('/');
  }
  const position = origin?.lat && origin?.lon ? `/POS/${encodeURIComponent(origin.address)}::${origin.lat},${origin.lon}` : '/POS';
  return `${urlStart}/${mode.toUpperCase()}${position}`;
}

function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function NearYouButton({
  mode,
  modeSet,
  colors,
  title = '',
  titleWeight,
  withAlert = false,
  boxed = false,
  withBorder = false,
  withArrow = false,
  margin = '8px',
  padding = '8px',
  iconSize
}) {
  let iconProps;
  if (mode === 'favorite') {
    iconProps = {
      img: 'star'
    };
  } else if (mode === 'more') {
    iconProps = {
      img: 'arrow',
      color: colors.primary,
      width: 1.2,
      height: 1.2
    };
  } else {
    iconProps = {
      img: getIconName(mode, modeSet, boxed),
      color: colors[mode]
    };
  }
  if (!boxed) {
    iconProps = _objectSpread$1(_objectSpread$1({}, iconProps), {}, {
      width: 1.4,
      height: 1.4
    });
  }
  const buttonStyle = {
    '--margin': margin,
    '--padding': padding
  };
  let iconContainerStyle = {
    '--iconMargin': padding
  };
  if (iconSize) {
    iconContainerStyle['--iconSize'] = iconSize;
  }
  if (!boxed) {
    iconContainerStyle = _objectSpread$1(_objectSpread$1({}, iconContainerStyle), {}, {
      '--bckColor': colors[mode],
      '--borderRadius': '50%',
      '--iconMargin': '17px'
    });
  }
  const buttonClass = withBorder ? 'near-you-button-with-border' : 'near-you-button';
  return /*#__PURE__*/jsxs("div", {
    "aria-hidden": "true",
    className: styles[buttonClass],
    style: buttonStyle,
    children: [/*#__PURE__*/jsxs("span", {
      className: styles['icon-container'],
      style: iconContainerStyle,
      children: [/*#__PURE__*/jsx(Icon, _objectSpread$1({}, iconProps)), withAlert && /*#__PURE__*/jsx("span", {
        className: styles['transport-mode-alert-icon'],
        children: /*#__PURE__*/jsx(Icon, {
          img: "caution",
          color: colors.caution
        })
      })]
    }), title && /*#__PURE__*/jsx("span", {
      className: styles['transport-mode-title'],
      style: titleWeight ? {
        '--font-weight': titleWeight
      } : undefined,
      children: title
    }), withArrow && /*#__PURE__*/jsx("div", {
      className: styles['near-you-button-caret'],
      children: /*#__PURE__*/jsx(Icon, {
        img: "arrow",
        color: colors.primary,
        width: 0.9,
        height: 0.9
      })
    })]
  });
}
process.env.NODE_ENV !== "production" ? NearYouButton.propTypes = {
  mode: PropTypes.string.isRequired,
  modeSet: PropTypes.string.isRequired,
  colors: PropTypes.objectOf(PropTypes.string).isRequired,
  title: PropTypes.string,
  titleWeight: PropTypes.number,
  withAlert: PropTypes.bool,
  boxed: PropTypes.bool,
  withBorder: PropTypes.bool,
  withArrow: PropTypes.bool,
  margin: PropTypes.string,
  padding: PropTypes.string,
  iconSize: PropTypes.string
} : void 0;

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const MODAL_FONT_WEIGHT = 325;

/** Keyboard and pointer accessible link-like button for one transport mode */
function ModeButton({
  mode,
  language,
  modeSet,
  colors,
  withAlert,
  loading,
  horizontal,
  inModal,
  onActivate
}) {
  const [t] = useTranslation();
  const buttonProps = {
    mode,
    modeSet,
    colors,
    withAlert,
    boxed: inModal || horizontal // squared icon or interior only
  };
  if (inModal) {
    const titleKey = modeSet === 'hsl' && mode === 'rail' ? 'rail_local' : `${mode}_short`;
    buttonProps.title = t(titleKey, {
      lng: language
    });
    buttonProps.titleWeight = MODAL_FONT_WEIGHT;
    buttonProps.withArrow = true;
    buttonProps.margin = '0';
    buttonProps.padding = '6px';
  } else {
    buttonProps.withBorder = true;
    if (!horizontal) {
      buttonProps.title = t(mode, {
        lng: language
      });
    }
  }
  return /*#__PURE__*/jsx("div", {
    "aria-label": t(mode, {
      lng: language
    }),
    role: "link",
    tabIndex: "0",
    onClick: () => onActivate(),
    onKeyDown: e => {
      if (isKeyboardSelectionEvent(e)) {
        onActivate(e);
      }
    },
    children: /*#__PURE__*/jsx(Shimmer, {
      active: loading,
      children: /*#__PURE__*/jsx(NearYouButton, _objectSpread({}, buttonProps))
    })
  });
}
process.env.NODE_ENV !== "production" ? ModeButton.propTypes = {
  mode: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
  modeSet: PropTypes.string.isRequired,
  colors: PropTypes.objectOf(PropTypes.string).isRequired,
  withAlert: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  horizontal: PropTypes.bool.isRequired,
  inModal: PropTypes.bool.isRequired,
  onActivate: PropTypes.func.isRequired
} : void 0;

const NO_MODES = [];

/** Returns upper case names of the modes that currently have alerts */
function useModesWithAlerts(alertsContext) {
  const [modes, setModes] = useState(NO_MODES);
  useEffect(() => {
    if (!alertsContext) {
      return undefined;
    }
    let cancelled = false;
    alertsContext.getModesWithAlerts(alertsContext.currentTime, alertsContext.feedIds).then(res => {
      if (!cancelled) {
        setModes(res);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return modes;
}

const MAX_VISIBLE_MODES = 7;
const MORE = 'more';
function NearStopsAndRoutes({
  horizontal = true,
  modeArray,
  language = 'fi',
  title,
  alertsContext,
  origin,
  onClick,
  modeSet = 'hsl',
  colors = defaultColors,
  urlPrefix,
  omitLanguageUrl = false,
  loading = true
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const [t] = useTranslation();
  const modesWithAlerts = useModesWithAlerts(alertsContext);
  const modes = modeArray.filter(mode => VALID_NEAR_YOU_MODES.includes(mode));
  const useModal = horizontal && modes.length > MAX_VISIBLE_MODES;
  const visibleModes = useModal ? [...modes.slice(0, MAX_VISIBLE_MODES - 1), MORE] : modes;
  const renderButton = (mode, inModal) => /*#__PURE__*/jsx(ModeButton, {
    mode: mode,
    language: language,
    modeSet: modeSet,
    colors: colors,
    withAlert: modesWithAlerts.includes(mode.toUpperCase()),
    loading: loading,
    horizontal: horizontal,
    inModal: inModal,
    onActivate: mode === MORE ? () => setModalOpen(true) : e => onClick(getModeUrl({
      urlPrefix,
      language,
      omitLanguageUrl,
      origin,
      mode
    }), e)
  }, mode);
  return /*#__PURE__*/jsxs("div", {
    className: styles['near-you-container'],
    children: [useModal && /*#__PURE__*/jsx(AllModesModal, {
      language: language,
      modalOpen: modalOpen,
      closeModal: () => setModalOpen(false),
      children: modes.map((mode, i) => /*#__PURE__*/jsxs("div", {
        children: [renderButton(mode, true), i < modes.length - 1 && /*#__PURE__*/jsx("div", {
          className: styles.separator
        })]
      }, mode))
    }), /*#__PURE__*/jsx("h2", {
      className: styles['near-you-title'],
      children: title?.[language] || t('title', {
        lng: language
      })
    }), /*#__PURE__*/jsx("div", {
      className: horizontal ? styles['near-you-buttons-container'] : styles['near-you-buttons-container-wide'],
      children: visibleModes.map(mode => renderButton(mode, false))
    })]
  });
}
process.env.NODE_ENV !== "production" ? NearStopsAndRoutes.propTypes = {
  loading: PropTypes.bool,
  modeArray: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.objectOf(PropTypes.string),
  language: PropTypes.string,
  horizontal: PropTypes.bool,
  alertsContext: PropTypes.shape({
    getModesWithAlerts: PropTypes.func,
    currentTime: PropTypes.number,
    feedIds: PropTypes.arrayOf(PropTypes.string)
  }),
  origin: PropTypes.shape({
    address: PropTypes.string,
    lat: PropTypes.number,
    lon: PropTypes.number
  }),
  onClick: PropTypes.func.isRequired,
  colors: PropTypes.objectOf(PropTypes.string),
  modeSet: PropTypes.string,
  urlPrefix: PropTypes.string.isRequired,
  omitLanguageUrl: PropTypes.bool
} : void 0;

/* eslint sort-keys: "error" */
const translations = {
  de: {
    translation: {
      airplane: 'Flug',
      bus: 'Bus',
      citybike: 'Leihrad',
      close: 'Schließen',
      favorite: 'Favoriten',
      ferry: 'Fähre',
      rail: 'Zug',
      subway: 'U-Bahn',
      title: 'Haltestellen und Linien in der Nähe',
      tram: 'Straßenbahn'
    }
  },
  en: {
    translation: {
      airplane: 'Nearest airports',
      airplane_short: 'Airport',
      bikepark: 'Nearest bike Park & Ride sites',
      bikepark_short: 'Park & Ride (Bikes)',
      bus: 'Buses and nearby stops on a map',
      bus_short: 'Bus',
      carpark: 'Nearest car Park & ride sites',
      carpark_short: 'Park & Ride (Cars)',
      citybike: 'Nearest city bike stations',
      citybike_short: 'City bike',
      close: 'Close',
      description: 'The Near You view shows all stops and routes near you at a glance.',
      favorite: 'Nearest favorites',
      favorite_short: 'Favorites',
      ferry: 'Nearest ferry piers',
      ferry_short: 'Ferry',
      more: 'Show more',
      rail: 'Trains and nearby stations on a map',
      rail_local: 'Commuter train',
      rail_short: 'Train',
      subway: 'Metro and nearby stations on a map',
      subway_short: 'Metro',
      title: 'Near you',
      tram: 'Trams and nearby stops on a map',
      tram_short: 'Tram'
    }
  },
  fi: {
    translation: {
      airplane: 'Lähimmät lentoasemat',
      airplane_short: 'Lentoasema',
      bikepark: 'Lähimmät liityntäpysäköinnit pyörille',
      bikepark_short: 'Liityntäpysäköinti pyörille',
      bus: 'Bussit ja lähipysäkit kartalla',
      bus_short: 'Bussi',
      carpark: 'Lähimmät liityntäpysäköinnit autoille',
      carpark_short: 'Liityntäpysäköinti autoille',
      citybike: 'Lähimmät kaupunkipyöräasemat',
      citybike_short: 'Kaupunkipyörä',
      close: 'Sulje',
      description: 'Lähelläsi-näkymä näyttää yhdellä kertaa pysäkit ja linjat lähelläsi.',
      favorite: 'Lähimmät suosikit',
      favorite_short: 'Suosikit',
      ferry: 'Lähimmät lauttalaiturit',
      ferry_short: 'Lautta',
      more: 'Näytä lisää',
      rail: 'Junat ja lähiasemat kartalla',
      rail_local: 'Lähijuna',
      rail_short: 'Juna',
      subway: 'Metrot ja lähiasemat kartalla',
      subway_short: 'Metro',
      title: 'Lähelläsi',
      tram: 'Raitiovaunut ja lähipysäkit kartalla',
      tram_short: 'Raitiovaunu'
    }
  },
  pl: {
    translation: {
      airplane: 'Lot',
      bus: 'Autobus',
      citybike: 'Rower miejski',
      favorite: 'Przystanki w pobliżu',
      ferry: 'Prom',
      rail: 'Kolej',
      subway: 'Metro',
      sulje: 'Zamknij',
      title: 'Przystanki i trasy w pobliżu',
      tram: 'Tramwaj'
    }
  },
  sv: {
    translation: {
      airplane: 'De närmaste flygplatserna',
      airplane_short: 'Flygplatsen',
      bikepark: 'Anslutningsparkering för cyklar',
      bikepark_short: 'Anslutningsparkering för cyklar',
      bus: 'Bussar och närmaste hållplatser',
      bus_short: 'Buss',
      carpark: 'Anslutningsparkering för bilar',
      carpark_short: 'Anslutningsparkering för bilar',
      citybike: 'Närmaste stadscykelstationer',
      citybike_short: 'Stadscykel',
      close: 'Stäng',
      description: 'I vyn Nära dig kan du se hållplatserna och linjerna nära dig.',
      favorite: 'Närmaste favoriter',
      favorite_short: 'Favoriter',
      ferry: 'Närmaste färjekajer',
      ferry_short: 'Färja',
      more: 'Visa flera',
      rail: 'Tåg och närmaste stationer',
      rail_local: 'Närtåg',
      rail_short: 'Tåg',
      subway: 'Metron och närmaste stationer',
      subway_short: 'Metro',
      title: 'Nära dig',
      tram: 'Spårvagnar och närmaste hållplatser',
      tram_short: 'Spårvagn'
    }
  }
};

const i18n = createInstance({
  fallbackLng: 'fi',
  // debug: true,
  resources: translations,
  defaultNS: 'translation',
  react: {
    useSuspense: true
  }
});
i18n.init();

const DEFAULT_CHILDREN = [];
function SeparatorLine({
  usePaddingBottom20 = false
}) {
  const className = usePaddingBottom20 ? styles['separator-div2'] : styles['separator-div'];
  return /*#__PURE__*/jsx("div", {
    className: className,
    children: /*#__PURE__*/jsx("div", {
      className: styles['separator-line']
    })
  });
}
process.env.NODE_ENV !== "production" ? SeparatorLine.propTypes = {
  usePaddingBottom20: PropTypes.bool
} : void 0;

/**
 * CtrlPanel gathers multiple components to same area (desktop-size: left or mobile-size: bottom)
 *
 * @param {Object} props
 * @param {string} props.position - 'left' or 'bottom'
 * @param {node} props.children - panel content
 * @example
 * <CtrlPanel language="fi" position="left">
 *    <CtrlPanel.SeparatorLine />
 *    <CtrlPanel.NearStopsAndRoutes
 *      modearray={['bus', 'tram', 'subway', 'rail', 'ferry', 'citybike']}
 *      language="fi"
 *    />
 *  </CtrlPanel>
 */
function CtrlPanel({
  children = DEFAULT_CHILDREN,
  position
}) {
  const className = position === 'bottom' ? styles['main-bottom'] : styles['main-left'];
  return /*#__PURE__*/jsx(I18nextProvider, {
    i18n: i18n,
    children: /*#__PURE__*/jsx("div", {
      className: className,
      children: children
    })
  });
}

/**
 * @name CtrlPanel.NearStopsAndRoutes
 * @static
 *
 * Show button links to near you page for different travel modes
 *
 * @param {Object} props
 * @param {string[]} props.modeArray - Names of transport modes to show buttons for. Should be in lower case. Also defines button order
 * @param {string} props.language - Language used for accessible labels
 * @param {Object} props.title - Custom titles per language
 * @param {Object} props.alertsContext
 * @param {function} props.alertsContext.getModesWithAlerts - Function which should return an array of transport modes that have active alerts (e.g. [BUS, SUBWAY])
 * @param {Number} props.alertsContext.currentTime - Time stamp with which the returned alerts are validated with
 * @param {Number} props.alertsContext.feedIds - feedIds for which the alerts are fetched for
 * @param {Object} props.colors - theme color configuration
 * @param {string} props.urlPrefix - URL prefix for links
 * @example
 * const alertsContext = {
 *    getModesWithAlerts: () => ({}),
 *    currentTime: 123456789,
 *    feedIds: [HSL]
 * }
 * <CtrlPanel.NearStopsAndRoutes
 *      modeArray={['bus', 'tram', 'subway', 'rail', 'ferry', 'citybike']}
 *      language="fi"
 *      alertsContext={alertsContext}
 *    />
 *
 */
CtrlPanel.NearStopsAndRoutes = NearStopsAndRoutes;
CtrlPanel.SeparatorLine = SeparatorLine;
process.env.NODE_ENV !== "production" ? CtrlPanel.propTypes = {
  children: PropTypes.node,
  position: PropTypes.string.isRequired
} : void 0;

export { CtrlPanel as default };
//# sourceMappingURL=index.js.map
